import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getImageUrl(path) {
  if (!path) return null;
  if (typeof path !== 'string') return null;
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('blob:') || path.startsWith('data:')) {
    return path;
  }
  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function getUserAvatar(userData) {
  if (!userData) return null;
  const path = userData.profile_image || userData.profile_photo || userData.profilePicture || userData.avatar || null;
  return getImageUrl(path);
}
